import React, { useEffect, useState } from "react";
import PageBanner from "../../components/PageBanner";
import BulletParagraph from "../../components/content/BulletParagraph";
import ServiceService from "../../services/service";
import { useParams } from "react-router-dom";
import RichText from "../../components/content/RichText";
import ContentImage from "../../components/content/ContentImage";
import ComingSoon, { ComingSoonBox } from "../ComingSoon";

export default function ServiceDetail(props) {
  let [serviceData, setServiceData] = useState([]);
  // เมนูบริการที่เพิ่มไว้แล้วแต่ยังไม่มีข้อมูลใน Strapi -> หน้า "เร็วๆ นี้"
  let [notFound, setNotFound] = useState(false);
  let { id, lang } = useParams();

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  const getServiceData = async () => {
    try {
      let res = await ServiceService.getServiceByName(`/${id}`);

      if (res) {
        setServiceData(res);
      } else {
        setNotFound(true);
      }
    } catch {
      console.error();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getServiceData();
    // eslint-disable-next-line
  }, []);

  function serviceTitle(text) {
    return (
      <h1 className="text-heading font-bold text-slateGray text-left my-[50px]">
        {text}
      </h1>
    );
  }

  function serviceImage(data) {
    return (
      <div
        className={
          `flex items-start gap-[46px] ` + (!data.imageIsLeft && "flex-row-reverse")
        }
      >
        <ContentImage image={data?.image} lang={lang} />
        <RichText
          className="w-full"
          html={
            lang === "th" ? data.detail?.[0]?.detail_TH : data.detail?.[0]?.detail_EN
          }
        />
      </div>
    );
  }

  const bannerText = [
    { name: "service", href: "/service" },
    {
      name: serviceData?.link?.label_EN,
    },
  ];

  if (notFound) return <ComingSoon />;

  const hasContent = serviceData.content && serviceData.content.length > 0;

  return (
    <div className="service-info pt-[135px] lg:pt-[0px]">
      {serviceData.link ? (
        <PageBanner
          banner={serviceData.banner}
          text_th={`${serviceData.link.label_TH}`}
          text_en={`${serviceData.link.label_EN}`}
          bannerText={bannerText}
          lang={lang}
        />
      ) : (
        <PageBanner text_th={``} text_en={``} />
      )}

      <div className="section">
        <div className="page-container">
          {/* บริการ แยก */}
          <div className="mt-[92px] mb-[300px]">
            {serviceData.link && serviceData.link.label_TH && (
              <h1 className="text-heading font-bold text-slateGray text-left">
                {lang === "th"
                  ? serviceData.link.label_TH
                  : serviceData.link.label_EN}
              </h1>
            )}
            <div>
              {serviceData.content &&
                serviceData.content.map((service, i) => (
                  <div key={i}>
                    {service.__component === "global.title" &&
                      serviceTitle(
                        lang === "th" ? service.title_th : service.title_en,
                      )}

                    {service.__component === "global.image-content" &&
                      serviceImage(service)}

                    {(service.__component === "global.detail" ||
                      service.__component === "global.rich-detail") && (
                      <RichText
                        html={
                          lang === "th" ? service.detail_TH : service.detail_EN
                        }
                      />
                    )}

                    {service.__component === "about.bullet" && (
                      <div className="mt-[32px]">
                        {BulletParagraph(
                          lang === "th" ? service.title_TH : service.title_EN,
                          lang === "th" ? service.detail_TH : service.detail_EN,
                        )}
                      </div>
                    )}
                  </div>
                ))}
            </div>
            {serviceData.link && !hasContent && <ComingSoonBox lang={lang} />}
          </div>
        </div>
      </div>
    </div>
  );
}
